//src/styles/components/MuiIconButton.js
import palette from "../palette";

const MuiIconButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: palette.text?.secondary || "#757575", 
      transition: theme?.transitions?.default || "all 0.3s ease", 
      "&:hover": { 
        color: palette.primary?.main || "#1976d2", 
        backgroundColor: palette.primary?.alpha?.['10'] || "rgba(25, 118, 210, 0.1)" 
      }, 
      "&.Mui-disabled": { 
        color: palette.text?.disabled || "rgba(0, 0, 0, 0.38)" 
      } 
    }),
  },
};

export default MuiIconButton;